import bcrypt from 'bcryptjs'

export default (enteredText: string, hash: string): boolean => bcrypt.compareSync(enteredText, hash)
